import React from "react";
import {
  Create,
  FormDataConsumer,
  SelectInput,
  TextInput,
  BooleanInput,
  required,
  ReferenceInput,
  ImageInput,
  ImageField,
  TabbedForm,
  SimpleForm,
  FormTab,
  DateInput,
  useNotify
} from "react-admin";
import { useStyles } from "../../../formStyles";
import { FormToolbar } from "../../../common/FormToolbar";
import moment from "moment";
import * as apiClient from "../../../common/apiClient";
import { toast } from "react-toastify";

const CustomerGroupCreate = (props) => {
  const classes = useStyles({});
  const notify = useNotify();
  let defaultValues = {
    isActive: true
  };
  const handleSubmit = async (formdata) => {
    let user: any = localStorage.getItem("userId");
    if (user) {
      user = parseInt(user);
    }
    let m = moment();

    let data = { ...formdata };
    data.modifyBy = user;
    data.createdBy = user;
    data.modifyDate = m.toISOString();
    data.createdDate = m.toISOString();
    data.code="-";

    apiClient.addRecord(data, "cust-groups").then(res => {
      notify("Customer Group is added succesffully");
      props.onClose();

    }).catch(err => {
      notify("unable to add Customer Group", "warning");
      toast.error("Validation issue : " + err, {
        position: "bottom-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        });
      console.log(err);
    });
  }

  return (
    <React.Fragment>
      <h5>Add Customer Group </h5>
      <SimpleForm variant="outlined" toolbar={<FormToolbar {...props} showDelete={false} showCancel={true} onCancel={props.onClose} onSave={handleSubmit} />} redirect="list" onSubmit={handleSubmit} initialValues={defaultValues} >

        {/* <TextInput source="code" fullWidth={true} validate={[required()]}   /> */}
        <TextInput source="name" fullWidth={true} validate={[required()]} />

        <BooleanInput source="isActive" label="Active" initialValue={true}/>
      </SimpleForm>

    </React.Fragment>
  );
};
export default CustomerGroupCreate;